<template>
  <div v-if="!item.summaryImagePath" class="price">
    <div class="item-image">
      <img v-lazy="item.imagePath" />
    </div>
    <span class="item-name">{{ item.priceName }}</span>
    <div v-if="typeof item.openPrice === 'undefined'">
      <div class="item-list-price">
        定価：{{ item.listPrice | toLocaleString }} 円（税込{{
          (item.listPrice * 1.1) | toLocaleString
        }}
        円）
      </div>
      <div class="item-regular-price">
        当社通常価格<br />
        {{ item.isCombo ? '1セット' : '1台' }}
        {{ item.regularPrice | toLocaleString }} 円（税込{{
          (item.regularPrice * 1.1) | toLocaleString
        }}
        円）
      </div>
    </div>
    <div v-else>
      <div class="item-list-price">
        オープン価格
      </div>
      <div class="item-regular-price">
        当社通常価格<br />
        {{ item.isCombo ? '1セット' : '1台' }}
        {{ item.regularPrice | toLocaleString }} 円（税込{{
          (item.regularPrice * 1.1) | toLocaleString
        }}
        円）
      </div>
    </div>
    <div v-if="item.accessoryPriceName">
      <span class="item-name" style="display: block; padding-top: 10px">{{
        item.accessoryPriceName
      }}</span>
      <div class="item-list-price">
        定価：{{ item.accessoryListPrice | toLocaleString }} 円（税込{{
          (item.accessoryListPrice * 1.1) | toLocaleString
        }}
        円）
      </div>
      <div class="item-regular-price">
        当社通常価格<br />
        1台
        {{ item.accessoryRegularPrice | toLocaleString }} 円（税込{{
          (item.accessoryRegularPrice * 1.1) | toLocaleString
        }}
        円）
      </div>
    </div>
  </div>
  <div v-else class="item-summary-image">
    <img v-lazy="item.summaryImagePath" />
  </div>
</template>

<script>
export default {
  props: ['item'],
}
</script>

<style scoped>
.price {
  font-size: 12px;

  align-self: flex-start;

  width: 23%;
  min-width: 200px;
  margin: 20px 1%;
}

.sp-product .price {
  width: 80%;
  max-width: 300px;
  margin-top: 0;
}

.item-summary-image {
  align-self: flex-start;

  width: 100%;
  margin: 20px 1%;

  border: 1px solid rgb(208, 209, 210);
}

.item-summary-image img {
  display: block;

  width: auto;
  max-width: 100%;
  height: auto;
  max-height: 100%;
  margin: auto;
}

.price .item-image {
  display: flex;

  width: 100%;
  height: 150px;
  margin: 10px auto 5px;

  border: 1px solid rgb(208, 209, 210);
}

.price img {
  display: block;

  width: auto;
  max-width: 90%;
  height: auto;
  max-height: 90%;
  margin: auto;
}

.price .item-name {
  font-weight: bold;

  white-space: pre-line;
}

.price .item-list-price {
  font-size: 10px;

  margin: 10px 0 0;
}

.price .item-regular-price {
  font-weight: bold;

  color: rgb(217, 10, 31);
}
</style>



// WEBPACK FOOTER //
// src/components/modules/products/Price.vue